<template >
  <span v-if="token == null" style="word-break: break-word">{{ userfullname }}</span>
  <router-link v-else style="word-break: break-word" @click="clickHandler()"
          :to="{
            name: route,
            params: {
              username: row[column.name],
            },
            query: {
              token: token
            }
          }"
          >{{ userfullname }}
  </router-link>
</template>

<script>

export default {
  props: {
    row: Object,
    column: Object,
    token:String,
    route: String
  },
  methods:{
    clickHandler(){
      this.$emit(
        "click"
      );
    }
  },
  computed: {
    url(){
      return this.href;
    },
    userfullname() {
      if (!this.row || !this.row[this.column.name]) {
        return this.column.default || "";
      }

      let userfullname = this.row[this.column.name].toUpperCase();

      if (this.row[this.column.nickname]) {
        userfullname += " (" + this.row[this.column.nickname] + ")";
      }

      return userfullname;
    },
  },
};
</script>
